import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, InputGroup, Modal, Nav, Row, Col, Table, } from 'react-bootstrap';
import ImageShow from "../../Uitiles/ImageShow";
import Paginationnew from "../../Uitiles/Paginationnew";
import { oneKlicks } from '../../SDK/oneclick';
import { toast } from 'react-toastify';
import AddAppointmentModal from '../Components/AddAppointmentModal';

const AppointmentList = () => {
    const [appointments, setAppointments] = useState([]);
    const [showAdd, setShowAdd] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState('');
    const [selectedHospital, setSelectedHospital] = useState('');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [filtered, setFiltered] = useState([]);

    const [showView, setShowView] = useState(false);
    const [selectedAppt, setSelectedAppt] = useState(null);

    const handleView = (appt) => {
        setSelectedAppt(appt);
        setShowView(true);
    };

    const createNotification = async (userId, title, message, type = 'appointment') => {
        try {
            await oneKlicks.create("", "notifications", {
                user_id: userId,
                title: title,
                message: message,
                type: type,
                is_read: 0,
                created_at: new Date().toISOString()
            });
        } catch (error) {
            console.error('Error creating notification:', error);
        }
    };

    const handleUpdateStatus = async (newStatus) => {
        if (!selectedAppt) return;
        try {
            const response = await oneKlicks.update("", "appointments", { status: newStatus }, { id: selectedAppt.id });
            if (response.success) {
                toast.success(`Status updated to ${newStatus}`);

                // Create Notification for Patient
                const doctorName = selectedAppt.doctor?.[0]?.display_name || 'your doctor';
                let title = '';
                let message = '';

                if (newStatus === 'confirmed') {
                    title = 'Appointment Confirmed';
                    message = `Your appointment with ${doctorName} on ${selectedAppt.appointment_date} has been confirmed.`;
                } else if (newStatus === 'follow-up') {
                    title = 'Follow-up Reminder';
                    message = `${doctorName} has sent you a follow-up reminder regarding your appointment.`;
                } else if (newStatus === 'pending') {
                    title = 'Appointment Status: Pending';
                    message = `Your appointment with ${doctorName} is currently under review.`;
                } else if (newStatus === 'cancelled') {
                    title = 'Appointment Cancelled';
                    message = `Your appointment with ${doctorName} has been cancelled by the administrator.`;
                }

                if (title && selectedAppt.patient_id) {
                    await createNotification(selectedAppt.patient_id, title, message);
                }

                fetchAppointments();
                setSelectedAppt(prev => ({ ...prev, status: newStatus }));
            }
        } catch (error) {
            console.error('Error updating status:', error);
            toast.error('Failed to update status');
        }
    };

    const fetchDropdownData = async () => {
        try {
            const doctorsRes = await oneKlicks.read("", "users", { user_type: 'doctor' }, "display_name ASC");
            if (doctorsRes.success) setDoctors(doctorsRes.data);

            const hospitalsRes = await oneKlicks.read("", "users", { user_type: 'hospitals' }, "display_name ASC");
            if (hospitalsRes.success) setHospitals(hospitalsRes.data);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    const fetchAppointments = async () => {
        try {
            setLoading(true);
            const conditions = {};
            if (selectedDoctor) conditions.doctor_id = selectedDoctor;
            if (selectedHospital) conditions.hospital_id = selectedHospital;

            const response = await oneKlicks.read("", "appointments", conditions, "id DESC", search, { page, limit }, [
                { target_table: 'users', target_column: 'id', target_value: 'patient_id', target_label: 'patient' },
                { target_table: 'users', target_column: 'id', target_value: 'doctor_id', target_label: 'doctor' },
                { target_table: 'users', target_column: 'id', target_value: 'hospital_id', target_label: 'hospital' }
            ]);

            if (response.success) {
                setAppointments(response.data);
                setFiltered(response.data);
                setTotalPages(Math.ceil(response.totalCount / limit) || 1);
            }
        } catch (error) {
            console.error('Error fetching appointments:', error);
            toast.error('Failed to load appointments');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, []);

    useEffect(() => {
        fetchAppointments();
    }, [page, limit, search, selectedDoctor, selectedHospital]);

    const handleDelete = async (appointment) => {
        if (!window.confirm('Are you sure you want to delete this appointment?')) return;
        try {
            const response = await oneKlicks.delete("", "appointments", { id: appointment.id });
            if (response.success) {
                toast.success('Appointment deleted successfully');

                // Notify patient about cancellation/deletion
                if (appointment.patient_id) {
                    const doctorName = appointment.doctor?.[0]?.display_name || 'the doctor';
                    await createNotification(
                        appointment.patient_id,
                        'Appointment Removed',
                        `Your scheduled appointment with ${doctorName} has been removed from the schedule.`
                    );
                }

                fetchAppointments();
            } else {
                toast.error('Failed to delete appointment');
            }
        } catch (error) {
            console.error('Error deleting appointment:', error);
            toast.error('Failed to delete appointment');
        }
    };

    const handleAddAppointment = () => {
        console.log("handleAddAppointment");
        setShowAdd(true);
    }



    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Appointments</h5>
                                <Badge bg="info">Manage Appointments</Badge>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between align-items-center" style={{ gap: 12 }}>
                                <div className="d-flex gap-2 flex-grow-1" style={{ maxWidth: 800 }}>
                                    <InputGroup style={{ maxWidth: 300 }}>
                                        <Form.Control
                                            placeholder="Search..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </InputGroup>
                                    <Form.Select
                                        style={{ maxWidth: 250 }}
                                        value={selectedDoctor}
                                        onChange={(e) => setSelectedDoctor(e.target.value)}
                                    >
                                        <option value="">All Doctors</option>
                                        {doctors.map(d => (
                                            <option key={d.id} value={d.id}>{d.display_name}</option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select
                                        style={{ maxWidth: 250 }}
                                        value={selectedHospital}
                                        onChange={(e) => setSelectedHospital(e.target.value)}
                                    >
                                        <option value="">All Hospitals</option>
                                        {hospitals.map(h => (
                                            <option key={h.id} value={h.id}>{h.display_name}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                                <Button variant="primary" style={{ height: 40 }} onClick={() => handleAddAppointment()}>+ Add New Appointment</Button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Patient</th>
                                        <th>Doctor</th>
                                        <th>Hospital</th>
                                        <th>Time</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={8} className="text-center py-5">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : filtered.length === 0 ? (
                                        <tr>
                                            <td colSpan={8} className="text-center text-muted py-4">No appointments found.</td>
                                        </tr>
                                    ) : filtered.map((appt) => (
                                        <tr key={appt.id}>
                                            <td>#{appt.id}</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <ImageShow url={appt.patient?.[0]?.profile_photo_url} width={30} height={30} style={{ borderRadius: '50%' }} />
                                                    <span>
                                                        {appt.patient?.[0]
                                                            ? `${appt.patient[0].first_name || ''} ${appt.patient[0].last_name || ''}`.trim() || appt.patient[0].display_name
                                                            : 'N/A'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{appt.doctor?.[0]?.display_name || 'N/A'}</td>
                                            <td>{appt.hospital?.[0]?.display_name || 'N/A'}</td>
                                            <td>{appt.appointment_time || 'N/A'}</td>
                                            <td>{appt.appointment_date || 'N/A'}</td>
                                            <td>
                                                <Badge bg={
                                                    appt.status === 'confirmed' ? 'success' :
                                                        appt.status === 'pending' ? 'warning' :
                                                            appt.status === 'cancelled' ? 'danger' : 'info'
                                                }>
                                                    {appt.status || 'Scheduled'}
                                                </Badge>
                                            </td>
                                            <td>
                                                <div className="d-flex" style={{ gap: 8 }}>
                                                    <Button size="sm" variant="outline-primary" onClick={() => handleView(appt)}>View</Button>
                                                    <Button size="sm" variant="outline-danger" onClick={() => handleDelete(appt)}>Delete</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        <Paginationnew
                            currentPage={page}
                            totalPages={totalPages}
                            handlePageChange={setPage}
                        />
                    </div>
                </div>


            </div>

            {showAdd && (
                <AddAppointmentModal showAdd={showAdd} setShowAdd={setShowAdd} />
            )}

            {showView && selectedAppt && (
                <Modal show={showView} onHide={() => setShowView(false)} size="lg" centered backdrop="static" className="dc-appointment-modal">
                    <Modal.Header closeButton style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                        <Modal.Title style={{ fontSize: '1.2rem', fontWeight: '700', color: '#333' }}>
                            Appointment Review <span style={{ color: '#aaa', fontSize: '0.85rem', fontWeight: '400', marginLeft: '10px' }}>ID: #{selectedAppt.id}</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '0', backgroundColor: '#fff', overflowX: 'hidden' }}>
                        <div style={{ padding: '25px' }}>
                            {/* Visual Status Indicator */}
                            <div className="d-flex align-items-center mb-4 p-3" style={{ backgroundColor: '#fcfcfc', border: '1px solid #eee', borderRadius: '8px' }}>
                                <div className="mr-3" style={{ width: '45px', height: '45px', borderRadius: '50%', backgroundColor: selectedAppt.status === 'confirmed' ? '#d4edda' : selectedAppt.status === 'pending' ? '#fff3cd' : '#f8d7da', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className={`${selectedAppt.status === 'confirmed' ? 'ti-check text-success' : selectedAppt.status === 'pending' ? 'ti-timer text-warning' : 'ti-close text-danger'}`} style={{ fontSize: '1.2rem' }}></i>
                                </div>
                                <div>
                                    <div style={{ fontSize: '0.75rem', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' }}>Current State</div>
                                    <div style={{ fontWeight: '700', color: '#444', textTransform: 'capitalize' }}>{selectedAppt.status || 'Scheduled'}</div>
                                </div>
                                <Badge className="ml-auto p-2" bg={
                                    selectedAppt.status === 'confirmed' ? 'success' :
                                        selectedAppt.status === 'pending' ? 'warning' :
                                            selectedAppt.status === 'cancelled' ? 'danger' : 'info'
                                } style={{ minWidth: '100px' }}>
                                    {selectedAppt.status?.toUpperCase() || 'NEW'}
                                </Badge>
                            </div>
                            <Row className="mb-4">
                                <Col md={6} className="mb-3 mb-md-0">
                                    <div style={{ padding: '20px', border: '1px solid #ececec', borderRadius: '12px', height: '100%', backgroundColor: '#fff' }}>
                                        <h6 style={{ color: '#27ae60', fontWeight: '700', fontSize: '0.8rem', marginBottom: '15px', borderBottom: '1px solid #f5f5f5', paddingBottom: '10px', textTransform: 'uppercase' }}>
                                            <i className="ti-user mr-2"></i> Patient Information
                                        </h6>
                                        <div className="d-flex align-items-center mb-3">
                                            <ImageShow
                                                url={selectedAppt.patient?.[0]?.profile_photo_url}
                                                width={50}
                                                height={50}
                                                style={{ borderRadius: '10px', objectFit: 'cover' }}
                                            />
                                            <div className="ml-3">
                                                <div style={{ fontWeight: '700', color: '#333', fontSize: '1rem' }}>
                                                    {selectedAppt.patient?.[0]
                                                        ? `${selectedAppt.patient[0].first_name || ''} ${selectedAppt.patient[0].last_name || ''}`.trim() || selectedAppt.patient[0].display_name
                                                        : 'Patient Name N/A'}
                                                </div>
                                                <div className="text-muted small">{selectedAppt.patient?.[0]?.email || 'No email provided'}</div>
                                            </div>
                                        </div>
                                        <div style={{ fontSize: '0.85rem' }}>
                                            <div className="mb-1"><strong>Phone:</strong> <span className="text-muted ml-1">{selectedAppt.patient?.[0]?.phone || '--'}</span></div>
                                            <div><strong>Location:</strong> <span className="text-muted ml-1">{selectedAppt.patient?.[0]?.address || 'Not specified'}</span></div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div style={{ padding: '20px', border: '1px solid #ececec', borderRadius: '12px', height: '100%', backgroundColor: '#fff' }}>
                                        <h6 style={{ color: '#2980b9', fontWeight: '700', fontSize: '0.8rem', marginBottom: '15px', borderBottom: '1px solid #f5f5f5', paddingBottom: '10px', textTransform: 'uppercase' }}>
                                            <i className="ti-medall mr-2"></i> Assigned Doctor
                                        </h6>
                                        <div className="d-flex align-items-center mb-3">
                                            <ImageShow
                                                url={selectedAppt.doctor?.[0]?.profile_photo_url}
                                                width={50}
                                                height={50}
                                                style={{ borderRadius: '10px', objectFit: 'cover' }}
                                            />
                                            <div className="ml-3">
                                                <div style={{ fontWeight: '700', color: '#333', fontSize: '1rem' }}>
                                                    {selectedAppt.doctor?.[0]?.display_name || 'Assignment Pending'}
                                                </div>
                                                <div className="text-muted small">Specialized Practitioner</div>
                                            </div>
                                        </div>
                                        <div style={{ fontSize: '0.85rem' }}>
                                            <div className="mb-1"><strong>Hospital:</strong> <span className="text-muted ml-1">{selectedAppt.hospital?.[0]?.display_name || 'N/A'}</span></div>
                                            <div><strong>Facility:</strong> <span className="text-muted ml-1">{selectedAppt.hospital?.[0]?.address || 'N/A'}</span></div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <div style={{ padding: '20px', border: '1px solid #ececec', borderRadius: '12px', backgroundColor: '#fcfcfc' }}>
                                <h6 style={{ color: '#f39c12', fontWeight: '700', fontSize: '0.85rem', marginBottom: '15px' }}>
                                    <i className="ti-calendar mr-2"></i> DATE & TIME
                                </h6>
                                <Row className="text-center">
                                    <Col xs={6} md={3} style={{ borderRight: '1px solid #eee' }}>
                                        <div style={{ fontSize: '0.7rem', color: '#999', marginBottom: '5px' }}>APPT DATE</div>
                                        <div style={{ fontWeight: '700', color: '#333' }}>{selectedAppt.appointment_date || '--'}</div>
                                    </Col>
                                    <Col xs={6} md={3} style={{ borderRight: '1px solid #eee' }}>
                                        <div style={{ fontSize: '0.7rem', color: '#999', marginBottom: '5px' }}>TIME SLOT</div>
                                        <div style={{ fontWeight: '700', color: '#333' }}>{selectedAppt.appointment_time || '--'}</div>
                                    </Col>
                                    <Col xs={6} md={3} className="mt-3 mt-md-0" style={{ borderRight: '1px solid #eee' }}>
                                        <div style={{ fontSize: '0.7rem', color: '#999', marginBottom: '5px' }}>CONSULTATION</div>
                                        <div style={{ fontWeight: '700', color: '#333' }}>Standard</div>
                                    </Col>
                                    <Col xs={6} md={3} className="mt-3 mt-md-0">
                                        <div style={{ fontSize: '0.7rem', color: '#999', marginBottom: '5px' }}>TOKEN</div>
                                        <div style={{ fontWeight: '700', color: '#333' }}>#{selectedAppt.id}</div>
                                    </Col>
                                </Row>
                                {selectedAppt.note && (
                                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff', borderLeft: '4px solid #f39c12', borderRadius: '4px', fontSize: '0.85rem' }}>
                                        <div style={{ fontWeight: '700', color: '#856404', marginBottom: '5px' }}>Patient's Health Note:</div>
                                        <div style={{ color: '#555', fontStyle: 'italic' }}>"{selectedAppt.note}"</div>
                                    </div>
                                )}
                            </div>

                            <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '12px' }}>
                                <h6 style={{ fontWeight: '700', color: '#333', fontSize: '0.9rem', marginBottom: '15px' }}>QUICK FOLLOW-UP ACTIONS</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    <Button variant="success" className="btn-sm px-3" onClick={() => handleUpdateStatus('confirmed')} disabled={selectedAppt.status === 'confirmed'}>Confirm</Button>
                                    <Button variant="warning" className="btn-sm px-3 text-white" onClick={() => handleUpdateStatus('pending')} disabled={selectedAppt.status === 'pending'}>Pending</Button>
                                    <Button variant="info" className="btn-sm px-3" onClick={() => { toast.info("Reminder sent"); handleUpdateStatus('follow-up'); }}>Remind Patient</Button>
                                    <Button variant="danger" className="btn-sm px-3" onClick={() => handleUpdateStatus('cancelled')} disabled={selectedAppt.status === 'cancelled'}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ background: '#f8f9fa' }}>
                        <Button variant="outline-danger" className="mr-auto btn-sm" onClick={() => handleDelete(selectedAppt)}>Delete Record</Button>
                        <Button variant="secondary" className="btn-sm" onClick={() => setShowView(false)}>Close</Button>
                        <Button variant="primary" className="btn-sm" onClick={() => window.print()}><i className="ti-printer mr-1"></i> Print</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default AppointmentList;
